import { observer } from "mobx-react";
import { h } from "preact";
import { translate, t } from "../I18n";
import { makeImgUrl, setQueryParams } from "../utils/URL";
import Popover from "../utils/Popover";
import { useEffect } from "preact/hooks";
import ShowMore from "./ShowMore";
import { PLACEHOLDER_IMAGE_URN } from "../utils/placeholderImage";
import { filterProductPhoto } from "../services/hidePhotosExperiment";
import NumericStepper, { NumericStepperButton } from "./NumericStepper";
const IMAGE_PARAMS = {
    auto: "compress",
    crop: "focalpoint",
    fit: "crop",
    "max-h": "200",
    "max-w": "400",
};
const CrossSellingItemCounter = observer(({ behaviour }) => {
    const size = "large";
    const addLabel = translate(t.restaurants.menu.add);
    const addClass = "m-crossup__counter-btn--add";
    switch (behaviour.type) {
        case "Cart":
            return (h(NumericStepperButton, { type: "increment", onClick: () => behaviour.add(), ariaLabel: addLabel, className: addClass, size: size }));
        case "ProductCard":
            return (h(NumericStepper, { type: "dynamic", quantity: behaviour.quantity, canDecrement: behaviour.canDecrement, onDecrement: () => behaviour.decrement(), decrementAriaLabel: translate(t.restaurants.menu.remove), onIncrement: () => behaviour.increment(), incrementAriaLabel: addLabel, incrementClass: addClass, size: size }));
    }
});
function CrossSellingItem(props) {
    var _a;
    const { item } = props;
    const imageUrn = (_a = filterProductPhoto(item.image)) !== null && _a !== void 0 ? _a : PLACEHOLDER_IMAGE_URN;
    const imageSrc = setQueryParams(IMAGE_PARAMS, makeImgUrl(imageUrn));
    const hasAllergens = item.allergens.length > 0;
    return (h("article", { class: "m-crossup__item splide__slide" },
        h("div", { class: `m-crossup__item-content ${item.behaviour.isActive ? "is-active" : ""}` },
            h("picture", { class: "m-crossup__item-picture" },
                h("img", { class: "m-crossup__item-img", loading: "lazy", src: imageSrc, alt: item.name })),
            h("div", { class: "u-flex-grow" },
                h("h4", { class: "u-my0 u-font-size-inherit" },
                    h("span", { class: "m-crossup__item-title" }, item.name),
                    " ",
                    hasAllergens && h(Allergens, { allergens: item.allergens })),
                h(ShowMore, { containerClass: "d-flex flex-column", textClass: "m-crossup__item-desc" }, item.description),
                h("footer", { class: "d-flex justify-content-between align-items-center" },
                    h("div", { class: "m-crossup__price" }, item.price),
                    h(CrossSellingItemCounter, { behaviour: item.behaviour }))))));
}
var AllergenId;
(function (AllergenId) {
    AllergenId[AllergenId["Gluten"] = 1] = "Gluten";
    AllergenId[AllergenId["Crustaceans"] = 2] = "Crustaceans";
    AllergenId[AllergenId["Eggs"] = 3] = "Eggs";
    AllergenId[AllergenId["Fish"] = 4] = "Fish";
    AllergenId[AllergenId["Peanuts"] = 5] = "Peanuts";
    AllergenId[AllergenId["Soybeans"] = 6] = "Soybeans";
    AllergenId[AllergenId["Milk"] = 7] = "Milk";
    AllergenId[AllergenId["Nuts"] = 8] = "Nuts";
    AllergenId[AllergenId["Celery"] = 9] = "Celery";
    AllergenId[AllergenId["Mustard"] = 10] = "Mustard";
    AllergenId[AllergenId["Sesame"] = 11] = "Sesame";
    AllergenId[AllergenId["SulphurDioxide"] = 12] = "SulphurDioxide";
    AllergenId[AllergenId["Lupin"] = 13] = "Lupin";
    AllergenId[AllergenId["Molluscs"] = 14] = "Molluscs";
})(AllergenId || (AllergenId = {}));
function Allergens(props) {
    const { allergens } = props;
    // Array of ids sorted by allergen number
    const ids = allergens
        .map((allergen) => AllergenId[allergen])
        .sort((a, b) => a - b);
    // Short info is only allergen numbers
    const shortInfo = ids.join(", ");
    // Details are allergen numbers and names
    const details = ids
        .map((id) => {
        const name = translate(t.theme_defaults.menu.allergens.names[AllergenId[id]]);
        return `${id}. ${name}`;
    })
        .join(", ");
    useEffect(() => {
        // FIXME: create Preact Popover Component that uses `/utils/Popover.ts`
        // We don't have "dispose" popover listeners action
        Popover.init();
    }, []);
    return (h("button", { type: "button", class: "u-btn-unstyled u-va-top btn-wrap text-muted js-popover", "data-target": "#allergens-popover", "data-title": translate(t.theme_defaults.menu.allergens.label), "data-dismiss-btn": "close", "data-template-content": details, title: "" }, shortInfo));
}
export default observer(CrossSellingItem);
